export const findMaxDate = (dateStrings: string[]) => {
  // Преобразуем каждую строку в дату
  const dates = dateStrings.map((dateString) => new Date(dateString));

  // Инициализируем переменную с первой датой массива
  let [maxDate] = dates;

  // Самый частый кейс
  if (dates.length === 1) {
    return maxDate;
  }

  // Итерируемся по массиву дат и сравниваем их с максимальной датой
  dates.forEach((currentDate, index) => {
    if (index === 0) {
      return;
    }
    if (currentDate.getTime() > maxDate.getTime()) {
      maxDate = currentDate;
    }
  });

  // Возвращаем строковое представление максимальной даты
  return maxDate;
};
